import { useEffect, useRef } from "react";
import { PaperGradientBG } from "../kits/DesignKit";
import { scrollHeaderIntoView } from "./utils/scrollToHeader";

function SectionZen({ onToggle, isOpen = false, headerRef }) {
  const localHeaderRef = useRef(null);
  const resolvedHeaderRef = headerRef || localHeaderRef;

  useEffect(() => {
    if (!isOpen || !resolvedHeaderRef.current) return;
    scrollHeaderIntoView(resolvedHeaderRef.current, "smooth", 8);
  }, [isOpen, resolvedHeaderRef]);

  return (
    <PaperGradientBG variant="zen151515">
      <section className="py-16 sm:py-20">
        <div
          ref={resolvedHeaderRef}
          className="group max-w-4xl mx-auto px-6 text-center font-mono cursor-pointer select-none"
          style={{ scrollMarginTop: "calc(var(--navbar-height, 0px) + 12px)" }}
          role="button"
          tabIndex={0}
          aria-expanded={isOpen}
          onClick={onToggle}
          onKeyDown={(e) => {
            if (e.key === "Enter" || e.key === " ") onToggle?.();
          }}
        >
          <p className="text-xs text-[#EFEBDC]/50 mb-3">
            <span className="text-[#AC8E66]">$</span> ls zendev/
          </p>
          <h1 className="text-2xl sm:text-3xl font-bold text-[#EFEBDC] mb-2 transition-colors duration-200 group-hover:text-[#AC8E66]">
            <span
              className={`inline-block text-brand/80 transition-transform duration-200 group-hover:scale-110 group-hover:text-[#AC8E66] ${
                isOpen ? "rotate-90" : "rotate-0"
              }`}
              aria-hidden="true"
            >
              &gt;
            </span>{" "}
            Softwareloesungen
          </h1>
          <p className="text-sm text-[#AC8E66]">
            <span className="text-[#AC8E66]">ZenDev</span>{" "}
            {isOpen ? "$ status ... ready" : "$ status ... standby"}
          </p>
          <p className="text-xs text-[#EFEBDC]/50 mt-4">
           Aus echter Praxis entwickelt
          </p>
        </div>
      </section>
    </PaperGradientBG>
  );
}

export default SectionZen;
